import { SHELF_UNITS_FETCH } from '../action-types/shelfUnits-types';
import { Maybe } from '../../types/common';
import { TShelfUnitEntity } from '../../types/entities';

type TShelfUnitReducerState = {
  entities: TShelfUnitEntity[];
  entity: Maybe<TShelfUnitEntity>;
  entityLoaded: boolean;
  loading: boolean;
};

const initialState: TShelfUnitReducerState = {
  entities: [],
  entity: null,
  entityLoaded: false,
  loading: false,
};

export default function (state = initialState, action): TShelfUnitReducerState {
  switch (action.type) {
    case SHELF_UNITS_FETCH.REQUEST:
    case SHELF_UNITS_FETCH.REJECTED:
      return {
        ...state,
        loading: true,
      };
    case SHELF_UNITS_FETCH.SUCCESS:
      return {
        ...state,
        entities: action.payload.data.sort(
          (entityA, entityB) => entityA.id - entityB.id,
        ),
        loading: false,
      };
    default:
      return state;
  }
}
